import getDateWithSlash from "../../getDateWithSlash";
import { serverLine } from "../../serverLine";

export default function savePomodoro({ sessionID, projectID }) {
  let date = getDateWithSlash(new Date());
  serverLine.post("/session", { sessionID, projectID, date });
}
